import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { Subscription } from 'rxjs';
import { HaloCustomLoaderService,HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { IstatusCountData } from '../../services/on-demand-classes.service.model';
import { DetaildViewHeadersOptions, DetailedViewHeaders, DetailsViewDataModel, DetailsViewGridData, StatsData } from '../../services/stats.model';
import { StatsService } from '../../services/stats.service';

@Component({
  selector: 'app-detailed-view',
  templateUrl: './detailed-view.component.html',
  styleUrls: ['./detailed-view.component.scss']
})
export class DetailedView implements OnInit {
  private sub = new Subscription(); 
  data: DetailsViewDataModel[];
  editDateVisible: boolean;
  headers: DetailedViewHeaders [] = []
  dateFrom: Date;
  dateTo: Date;
  connectedCount = 0;
  notConnectedCount = 0;
  idle = 0;
  service = 0;
  filterList: StatsData[] = [];
  doNotShowParent = false;
  type = 0;
  rootScopeData: RootScopeDeclare;
  canEdit = false;
  statusCountList: IstatusCountData;
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;
  constructor(
    private _statsService: StatsService,
    private _facilityService: FacilityService,
    private commonUtil: CommonUtil,
    private rootScopeService: RootScopeService,
    private haloCustomLoaderService: HaloCustomLoaderService,
  ) {}

  ngOnInit() {
    this.headers = [{
      label: this.commonUtil.translateText('EQUIPMENT'),
      dropdown: false,
    },
    {
      label: this.commonUtil.translateText('TOTAL.DISTANCE'),
      dropdown: true,
      drodownOptions: [DetaildViewHeadersOptions.TOTAL_DISTANCE, DetaildViewHeadersOptions.TOTAL_BELT_DISTANCE]
    },
    {
      label: this.commonUtil.translateText('TOTAL.HOURS'),
      dropdown: true,
      drodownOptions: [DetaildViewHeadersOptions.TOTAL_HOURS, DetaildViewHeadersOptions.TOTAL_BELT_HOURS, DetaildViewHeadersOptions.TOTAL_LIFT_HOURS]
    },
    {
      label: this.commonUtil.translateText('NO.OF.WORKOUTS'),
      dropdown: false,
    },
    {
      label: this.commonUtil.translateText('STATUS'),
      dropdown: false,
    },
    {
      label: this.commonUtil.translateText('SERVICE'),
      dropdown: false,
    }]

    const rootScopeServiceOnChange = this.rootScopeService.getRootScope().subscribe((val) => {
      this.rootScopeData = val;
    });
    this.sub.add(rootScopeServiceOnChange);
    
    if(localStorage.getItem('quickFilterStatus')){
      let quickFilterStatus = localStorage.getItem('quickFilterStatus');
      if(quickFilterStatus === 'connected'){
        this.type = 1;
      }else if(quickFilterStatus === 'disconnected'){
        this.type = 2;
      }else if(quickFilterStatus === 'idle'){
        this.type = 3;
      }
    }
    
    const statsDateFilterSub = this._statsService.statsDateFilterSubscriber.subscribe(val => {
        this.dateFrom = val.dateFrom;
        this.dateTo = val.dateTo;
        this.getData();
    })
    this.sub.add(statsDateFilterSub);

    const facilityServiceOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.canEdit = res.summary.userRights.stats === 'F';
      if(res.summary.facilityRights.stats !== 'false' && res.summary.userRights.stats !== 'H' ){
        this.getData();
      }
    });
    this.sub.add(facilityServiceOnChange)
    this.canEdit = this._facilityService.selectedFacility().summary.userRights.stats === 'F';
  }

  getData() {
    this.customLoaderIsLoading = true;
    const from = (this.dateFrom.getMonth() + 1) + '/' + this.dateFrom.getDate() +'/' + this.dateFrom.getFullYear();
    const to = (this.dateTo.getMonth() + 1) + '/' + this.dateTo.getDate() +'/' + this.dateTo.getFullYear();
    this._statsService.getDetailsViewData(this._facilityService.selectedFacilityId(), from, to, Intl.DateTimeFormat().resolvedOptions().timeZone).subscribe(data => {
      this.customLoaderIsLoading = false;
      this.connectedCount = 0;
      this.notConnectedCount = 0;
      this.idle = 0;
      this.service = 0;
      this.data = new DetailsViewGridData(data).detailsViewGridData;
      this.data.forEach(item => {
        this.connectedCount += item.statsData?.connectedEquipCount == undefined ? 0 : Number(item.statsData?.connectedEquipCount);
        this.notConnectedCount += item.statsData?.disconnectedEquipCount == undefined ? 0 : Number(item.statsData?.disconnectedEquipCount);
        this.idle += item.statsData?.idleEquipCount == undefined ? 0 : Number(item.statsData?.idleEquipCount);
        this.service += item.statsData?.isInspectBelt == undefined ? 0 : Number(item.statsData?.inspectBeltCount) > 0 ? Number(item.statsData?.inspectBeltCount) : 0;
        if(this.type > 0){
          this.reload(this.type);
        }

      });
      this.setLegendCounters();
    },err => {
      this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
    });
  }

  reload(type: number) {
    this.type = type;
    this.doNotShowParent = type> 0;
    if(type > 0) {
      this.filterList = [];
      this.data.forEach(dataItem => {
        dataItem.childs?.forEach(child => {
   
                if(child.statsData?.status === 'C' && type == 1) {
                  this.filterList.push(child);
                }
           
                if(child.statsData?.status === 'NC' && type == 2) {
                  this.filterList.push(child);
                }
             
                if(child.statsData?.status === 'I' && type == 3) {
                  this.filterList.push(child);
                }
             
                if(child.statsData?.isInspectBelt === 'true' && Number(dataItem.statsData?.inspectBeltCount) > 0 && type == 4) {
                  this.filterList.push(child);
                } 
        });
      });
    }else {
      
      this.doNotShowParent = false;
      this.filterList = [];
    }

  }

  scrollTop() {
    var scrollElem = document.querySelector('#moveTop');
    scrollElem?.scrollIntoView();  
  }

  export() {
    const from = (this.dateFrom.getMonth() + 1) + '/' + this.dateFrom.getDate() +'/' + this.dateFrom.getFullYear();
    const to = (this.dateTo.getMonth() + 1) + '/' + this.dateTo.getDate() +'/' + this.dateTo.getFullYear();
    const url = this._statsService.export(this._facilityService.selectedFacilityId(), from, to, new Date().getTimezoneOffset().toString(), this.rootScopeData.currentUser.userId);
      window.location.href = url; 
  }

  onDateRangeChange($event: any) {
    if($event.dateFrom && $event.dateTo) {
      const dateFrom = new Date($event.dateFrom.year, $event.dateFrom.month - 1, $event.dateFrom.day);
      const dateTo = new Date($event.dateTo.year, $event.dateTo.month - 1, $event.dateTo.day);
      if(this.dateFrom.toDateString() !== dateFrom.toDateString() || this.dateTo.toDateString() !== dateTo.toDateString()){
        this.dateFrom = new Date($event.dateFrom.year, $event.dateFrom.month - 1, $event.dateFrom.day);
        this.dateTo = new Date($event.dateTo.year, $event.dateTo.month - 1, $event.dateTo.day);
        this._statsService.updateStatsDateFilter({dateFrom: this.dateFrom, dateTo: this.dateTo});
      }
    }
 
    this.editDateVisible = $event.visible;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    localStorage.setItem('quickFilterStatus','');//Reset Default QuickFilter Status to All.
  }

  setLegendCounters() {
    let connected = 0;
    let disconected = 0;
    let idle = 0;
    this.data.forEach(item => {
      disconected += Number(item.statsData?.disconnectedEquipCount != null ? item.statsData?.disconnectedEquipCount : 0);
      connected += Number(item.statsData?.connectedEquipCount != null ? item.statsData?.connectedEquipCount : 0);
      idle += Number(item.statsData?.idleEquipCount != null ? item.statsData?.idleEquipCount : 0);
    });
    this.statusCountList = {
      connectedCount: connected,
      idleCount: idle,
      notConnectedCount: disconected,
      showIdle: true
    };
  }

  getFormat(date: string) {
    return 'MMM' + (new Date(date).getMonth() != 4 ? '. ': ' ') + 'dd, y';
  }
}
